module.exports = __webpack_public_path__ + "img/banner.b0c290ca.svg";